module.exports = __webpack_public_path__ + "img/R-5.7ecac67b.png";